export const categoriesData = [
    {
        name: 'refrigerators',
        label: 'Refrigerators',
        articles: {
            cooling_marvels:
                'Cooling Marvels: A Comprehensive Guide to Refrigerators for Your Home and Garden',
            cooling_wisdom: 'Cooling Wisdom: Prolonging the Life of Your Refrigerator with Pro Tips',
            mastering_art: 'Mastering the Art of Refrigerator Shopping: A Professional Guide to Smart Choices'
        }
    },
    {
        name: 'home_decor',
        label: 'Home decor',
        articles: {
            elevating_everyday:
                "Elevating Everyday Living: A Pro's Guide to Home Decor with Style and Comfort",
            illuminating_elegance: "Illuminating Elegance: A Pro's Guide to Lighting Design in Home Decor",
            urban_elegance: 'Urban Elegance to Suburban Serenity: Navigating the Shift in Home Decor'
        }
    },
    {
        name: 'the_north_face_coat',
        label: 'The north face coat',
        articles: {
            north_face: 'The North Face Coat: A Professional Exploration of Comfort, Style, and Performance',
            navigating_winter:
                'Navigating Winter and Hiking Adventures: The Unrivaled Excellence of The North Face Coat',
            timeless_elegance: 'Timeless Elegance: The North Face Coat in the Tapestry of Fashion'
        }
    },
    {
        name: 'tablet_on_sale',
        label: 'Tablet on sale',
        articles: {
            navigating_digital: 'Navigating the Digital Frontier: The Ultimate Guide to Tablets for Sale',
            unlocking_digital:
                'Unlocking the Digital World: Why Everyone Needs a Tablet, Especially Now with Sales',
            gift_possibilities: 'The Gift of Possibilities: Tablets as the Ultimate Christmas Present'
        }
    },
    {
        name: 'louis_vuitton_handbag',
        label: 'Louis vuitton handbag',
        articles: {
            elegance_enduring: 'Timeless Elegance: The Enduring Allure of Louis Vuitton Handbags',
            elegance_personified:
                'Elegance Personified: Louis Vuitton Handbags as the Ultimate Special Occasion Accessory',
            louis_vuitton: 'Louis Vuitton Handbags: A Timeless Investment and Vintage Haute Couture'
        }
    },
    {
        name: 'books',
        label: 'Books',
        articles: {
            enduring_pleasure: 'The Enduring Pleasure of Reading: Why Books Remain Timeless Treasures',
            embarking_literary: 'Embarking on a Literary Odyssey: Essential Books Everyone Must Read',
            gift_words: 'The Gift of Words: Unwrapping the Best Books for Christmas or Birthdays'
        }
    },
    {
        name: 'women_fashion',
        label: 'Women fashion',
        articles: {
            elegance_every: "Elegance in Every Thread: Navigating the World of Women's Fashion Styling",
            century_elegance:
                "A Century of Elegance: The Evolution of Women's Fashion Over the Last 100 Years",
            dawn_dusk: 'From Dawn to Dusk: Mastering Day-to-Night Fashion for Women'
        }
    },
    {
        name: 'baby_care',
        label: 'Baby care',
        articles: {
            navigating_tender: 'Navigating the Tender Path of Baby Care: A Comprehensive Guide',
            bathing_bliss: "Bathing Bliss: Elevating Your Baby's Shower Experience",
            nurturing_happiness:
                "Nurturing Happiness: A Comprehensive Guide to Ensuring Your Baby's Well-Being"
        }
    },
    {
        name: 'electronics',
        label: 'Electronics',
        articles: {
            digital_landscape: 'Navigating the Digital Landscape: Embracing the Wonders of Electronics',
            embarking_odyssey: 'Embarking on the AI Odyssey: Electronics in the Next Frontier',
            elevating_everyday: 'Elevating Everyday Living: The Harmony of Electronics in Smart Homes'
        }
    },
    {
        name: 'sports_and_outdoor',
        label: 'Sports and outdoor',
        articles: {
            unleashing_spirit:
                'Unleashing the Spirit of Adventure: The Evolution of Sport and Outdoor Sportswear',
            nature_playground: "Nature's Playground: Rediscovering the Joy of Outdoor Pursuits",
            elevating_health: 'Elevating Health: The Vital Role of Sport and Outdoor Activities'
        }
    },
    {
        name: 'computers',
        label: 'Computers',
        articles: {
            digital_nerve: 'The Digital Nerve Center: Navigating the Realm of Computers',
            digital_marketplace: 'Navigating the Digital Marketplace: A Guide to Choosing the Right Computer',
            unleashing_power: 'Unleashing the Power: The World of Gaming Computers'
        }
    },
    {
        name: 'men_fashion',
        label: 'Men fashion',
        articles: {
            mastering_art: "Mastering the Art: Navigating the World of Men's Fashion",
            sartorial_success: 'Sartorial Success: Mastering Professional Style in the Workplace',
            festive_flair: "Festive Flair: A Stylish Guide to Men's Holiday Fashion"
        }
    },
    {
        name: 'hoka_shoes_deals',
        label: 'Hoka shoes deals',
        articles: {
            step_comfort: 'Step into Comfort: The Hoka Shoe Revolution',
            every_stride: 'Elevating Every Stride: The Hoka Advantage for Runners',
            stepping_style: 'Stepping into Style: The Distinctive Aesthetics of Hoka Shoes'
        }
    },
    {
        name: 'water_bottles',
        label: 'Water bottles',
        articles: {
            hydration_style: 'Hydration in Style: The Evolution of Water Bottles',
            hydration_move: 'Hydration On the Move: The Essential Guide to Sport Water Bottles',
            quenching_wilderness: 'Quenching Wilderness Thirst: The Ultimate Guide to Camping Water Bottles'
        }
    },
    {
        name: 'luggage_suitcase',
        label: 'Luggage suitcase',
        articles: {
            navigating_world: 'Navigating the World: Unpacking the Essentials of Luggage Suitcases',
            skyward_selection:
                'Skyward Selection: Key Considerations for Choosing the Perfect Airplane-Friendly Luggage Suitcase',
            unpacking_excellence:
                'Unpacking Excellence: Navigating the Best Luggage Suitcases for Seamless Travel'
        }
    },
    {
        name: 'outdoor_cooking_buy_online',
        label: 'Outdoor cooking buy online',
        articles: {
            unleashing_culinary:
                'Unleashing Culinary Adventures: The Best Outdoor Cooking Gear to Buy Online',
            savoring_outdoors: 'Savoring the Outdoors: The Art of BBQ and Outdoor Cooking',
            sizzling_delights: 'Sizzling Delights: Exploring the World of Online Outdoor Cooking'
        }
    }
];
